import Dexie, { type Table } from 'dexie';
import { registerCleanup } from '../platform/cleanup';
import type { OutboxEntry, MetaRow, RejectionRow } from '../platform/sync-runner';

/**
 * The Morse module's local database — its own IndexedDB database
 * (`familyhub-morse`), the module-independence boundary on the client. Rows are
 * kept as the server sends them, tombstones included and filtered at read time.
 */

export interface MorseLetterRecord {
  id: string;
  letter: string;
  box: number;
  due_at: string | null;
  correct: number;
  wrong: number;
  word_hits: number;
  introduced_at: string | null;
  mastered_at: string | null;
  mnemonic: string | null;
  created_by: string | null;
  created_at?: string;
  updated_at: string;
  deleted_at: string | null;
}

export class MorseDb extends Dexie {
  letters!: Table<MorseLetterRecord, string>;
  outbox!: Table<OutboxEntry, number>;
  rejections!: Table<RejectionRow, string>;
  meta!: Table<MetaRow, string>;

  constructor() {
    super('familyhub-morse');
    this.version(1).stores({
      letters: 'id, letter, created_by, deleted_at',
      outbox: '++seq, queued_at',
      rejections: 'id, at',
      meta: 'key',
    });
  }
}

export const mdb = new MorseDb();

export const MORSE_TABLE_MAP = [
  { name: 'morse_letters', table: mdb.letters as unknown as Table<Record<string, unknown>, string> },
];

export async function clearMorseData(): Promise<void> {
  await Promise.all([mdb.letters.clear(), mdb.outbox.clear(), mdb.rejections.clear(), mdb.meta.clear()]);
}

registerCleanup(clearMorseData);
